import { render, staticRenderFns } from "./conceptCopy.vue?vue&type=template&id=49a7ddd8&scoped=true"
import script from "./conceptCopy.vue?vue&type=script&lang=js"
export * from "./conceptCopy.vue?vue&type=script&lang=js"
import style0 from "./conceptCopy.vue?vue&type=style&index=0&id=49a7ddd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7ddd8",
  null
  
)

export default component.exports